import React from "react";
import { Snackbar } from "@material-ui/core";
import MuiAlert from '@material-ui/lab/Alert';
import { useDispatch, useSelector } from "react-redux";
import { clearSnackbar } from '../../../redux/actions/ui';

// const useStyles = makeStyles(theme => ({
//   MuiAlert: {
//     standa: {
//       #3dbfbc
//     }
//   }
// }));


function SnackBar(props) {

  const dispatch = useDispatch();

  const { snackbarOpen, message, severity } = useSelector( state => state.ui );

  const handleClose = () => {
    dispatch(clearSnackbar());
  };

  return (
    <Snackbar open={snackbarOpen} autoHideDuration={5000} onClose={handleClose}>
      <MuiAlert elevation={6} variant="filled" onClose={handleClose} severity={severity || "success"}>
        {message}
      </MuiAlert>
    </Snackbar>
  )
}

export default SnackBar;